export class MoleculePanelServiceObjectDatabaseComponent {
    public templateUrl = require('./panel-service-object-database.html?external');
}
